const faqData = [
    {
        title: "Is this a subscription service?",
        text: "Nope—order a Fix delivery of curated pieces whenever you'd like, then instantly buy items from your very own shop anytime. There's no subscription required."
    },
    {
        title: "What do I pay and when?",
        text: "If you'd like pieces selected by your style expert, there's a $20 styling fee up front—and that fee gets credited toward anything you keep. (Don't worry, we'll let you preview items before we send anything your way.) You'll also get 25% off if you keep all five items in your Fix."
    },
    {
        title: "Will I be able to see items before they're sent in my Fix?",
        text: "Yes. We'll email a preview of your Fix before it ships, giving you the opportunity to collaborate and share feedback with your stylist. (We don't yet offer a preview for a kid's Fix.)"
    },
    {
        title: "What do items cost?",
        text: "We have items across every price range and carry thousands of just-right styles. Easily set your price preferences for each clothing category in your style quiz."
    },
    {
        title: "How do you find my style and fit?",
        text: "We're fit experts. We learn from your style quiz and ongoing feedback to pinpoint the best items for your taste, size and fit. Bonus: The more we interact, the more personalized your experience becomes."
    },
    {
        title: "Can I shop on my own without a stylist?",
        text: "Yes! After ordering your first Fix, you will be able to browse your own personalized store using Freestyle. Here, you'll be able able to shop outfit suggestions and new pieces refreshed daily, just for you. You can even shop to complete looks with items you purchased in your Fix."
    },
    {
        title: "Free shipping, returns & exchanges?",
        text: "Yep—shipping, returns & exchanges are always free. A prepaid return label is included with each order."
    }
]

export default faqData